/**
 * Created by marccurry on 2/27/16.
 */
(function ($) {
    'use strict';
    $('.accordion li').click( function(){

        var $target = $(this).find('.content');


        if( !$(this).hasClass('open')){

            $('.accordion li.open .content').slideUp(250);
            $('.accordion li.open').removeClass('open');

            $target.slideDown(250);
            $(this).addClass('open');
        }else{

            $('.accordion li.open .content').slideUp(250);
            $('.accordion li.open').removeClass('open');

        }



    })
})( jQuery );
